import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { SUPPORT_EMAIL } from '@/shared/constants/support';

/**
 * 停權申訴文案：請用戶來信客服信箱。
 * 用於帳號停權通知、偶像停權鎖定 modal。
 */
function SuspensionAppeal({ className = '' }) {
  const { t } = useTranslation();
  return (
    <p className={`text-gray small mb-0 ${className}`}>
      {t('suspension_appeal', { email: SUPPORT_EMAIL })}
    </p>
  );
}

SuspensionAppeal.propTypes = {
  className: PropTypes.string,
};

export default SuspensionAppeal;
